import i18n from 'modules/core/lib/i18n'

export const requisitionStatusLabel = (status: string) => {
  return {
    pending: i18n.t('ats.jobs_requisitions.status.pending'),
    approved: i18n.t('ats.jobs_requisitions.status.approved'),
    cancelled: i18n.t('ats.jobs_requisitions.status.cancelled'),
    rejected: i18n.t('ats.jobs_requisitions.status.rejected'),
  }[status]
}
